import {
    GET_SUBSCRIPTION_LIST_LIST_SUCCESS,
    GET_SUBSCRIPTION_LIST_LIST_REQUEST,
    GET_SUBSCRIPTION_LIST_LIST_FAILURE,
} from "../../actions/Subscription/subscribtionlistAction";
const initialState = {
    stateList: [],
};

export default function subscriptionReducer(state = initialState, action) {
    switch (action.type) {
        case GET_SUBSCRIPTION_LIST_LIST_REQUEST:
            return {
                ...state,
            };
        case GET_SUBSCRIPTION_LIST_LIST_SUCCESS:
            return {
                ...state,
                stateList: action.payload
            };
        case GET_SUBSCRIPTION_LIST_LIST_FAILURE:
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
}